"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  amp_status_bias_current_is: "amp_status_bias_current_is",
  amp_status_big_2nd_stage_gain: "amp_status_big_2nd_stage_gain",
  amp_status_cf_less_50fF: "amp_status_cf_less_50fF",
  amp_status_cf_less_100fF: "amp_status_cf_less_100fF",
  amp_status_cfb_no_cf: "amp_status_cfb_no_cf",
  amp_status_cfb_rf_too_small: "amp_status_cfb_rf_too_small",
  amp_status_dB_error: "amp_status_dB_error",
  amp_status_gbw_less_than_bandwith_requested: "amp_status_gbw_less_than_bandwith_requested",
  amp_status_high_vos: "amp_status_high_vos",
  amp_status_min_stable_gain: "amp_status_min_stable_gain",
  amp_status_negative_cf: "amp_status_negative_cf",
  amp_status_not_allowed: "amp_status_not_allowed",
  amp_status_not_enough_peaking: "amp_status_not_enough_peaking",
  amp_status_not_fast_enough: "amp_status_not_fast_enough",
  amp_status_not_recommended: "amp_status_not_recommended",
  amp_status_quad: "amp_status_quad",
  amp_status_internal_cf_too_high: "amp_status_internal_cf_too_high",
  amp_status_recommended: "amp_status_recommended",
  amp_status_slew_rate_low: "amp_status_slew_rate_low",
  amp_status_slew_rate_marginal: "amp_status_slew_rate_marginal",
  amp_status_specialty_amp: "amp_status_specialty_amp",
  amp_status_too_fast: "amp_status_too_fast",
  amp_status_voltage_not_enough: "amp_status_voltage_not_enough",
  amp_status_zero_drift: "amp_status_zero_drift",
  fixed_op_amp_no_good: "fixed_op_amp_no_good",
  no_op_amps_available_for_single_stage_too_fast: "no_op_amps_available_for_single_stage_too_fast",
  no_op_amps_available_for_single_stage_too_slow: "no_op_amps_available_for_single_stage_too_slow",
  no_op_amps_available_for_first_stage_too_fast: "no_op_amps_available_for_first_stage_too_fast",
  no_op_amps_available_for_first_stage_too_slow: "no_op_amps_available_for_first_stage_too_slow",
  no_op_amps_available_for_second_stage: "no_op_amps_available_for_second_stage",
  rf_too_high: "rf_too_high",
  currentCalculation_peak_light_error: "currentCalculation_peak_light_error",
  currentCalculation_peak_photodiode_error: "currentCalculation_peak_photodiode_error",
  amp_status_not_recommended_for_new_designs: "amp_status_not_recommended_for_new_designs",
  amp_status_last_time_buy: "amp_status_last_time_buy",
  amp_status_obsolete: "amp_status_obsolete"
};